const getDefaultState = () => {
    return {
        specialConditions: [],
        specialConditionTemplates: [],
        options: {},
        landlordData:{
            name: '',
            address: '',
            zipCode: '',
            city: '',
            email: '',
            cvr: '',
            type: ''
        },
        setTenantId: false,
        tenant:{},
        tenantList: []}
}


const state = getDefaultState()

const getters = {
    getOptions: (state) => state.options,
    getLandlordData: (state) => state.landlordData,
    getTenant: (state) => state.tenant,
    getTenantList: (state) => state.tenantList,
    getSelectedTenantId: (state) => state.setTenantId
};

const mutations = {
    resetContractWizardState: (state) => Object.assign(state, getDefaultState()),
    setOptions: (state, options) => state.options = options,
    setLandlordData: (state, data) => state.landlordData = data,
    setTenant: (state, tenant) => state.tenant = tenant,
    setTenantList: (state, list) => state.tenantList = list,
    setTenantId: (state, id) => state.setTenantId = id
};

const actions = {
    async fetchOptions({commit, state, getters}){
        await axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/contract/options/1',
            cancelToken: window.AuthorizationCancelSource.token,
        }).then(
            response => commit('setOptions', response.data)
        );
    },
    fetchLandlordData({commit, state}, data){
        commit('setLandlordData', data);
    },
    fetchTenant({commit, state}, data){
        commit('setTenant', data);
    },
    deleteTenant({commit, state}){
        commit('setTenant', {});
    },
    deleteLandlordData({commit, state}){
        commit('setLandlordData', {
            name: '',
            address: '',
            zipCode: '',
            city: '',
            email: '',
            cvr: ''
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
